import axios from 'axios';

const resolveApiBaseUrl = () => {
  const envBase = process.env.REACT_APP_API_BASE_URL;
  if (envBase && envBase.trim()) {
    return envBase.trim().replace(/\/+$/, '');
  }

  if (typeof window !== 'undefined' && window.location?.hostname) {
    const currentHost = window.location.hostname;
    if (
      currentHost === 'localhost'
      || currentHost === '127.0.0.1'
      || currentHost === '::1'
      || currentHost === '[::1]'
    ) {
      return 'http://127.0.0.1:8000/api';
    }
    return `http://${currentHost}:8000/api`;
  }

  return 'http://127.0.0.1:8000/api';
};

const api = axios.create({
  baseURL: `${resolveApiBaseUrl()}/`,
});


// Add a request interceptor to include the token in headers
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Add a response interceptor for centralized error handling
api.interceptors.response.use(
  response => response,
  error => {
    // Never use blocking browser alerts here; this interceptor can run repeatedly.
    if (error.response) {
      let userMessage = 'Request failed.';
      switch (error.response.status) {
        case 400:
          userMessage = 'Bad request. Please check your input.';
          break;
        case 401:
          userMessage = 'Unauthorized. Please log in again.';
          break;
        case 403:
          userMessage = 'Forbidden. You do not have permission.';
          break;
        case 404:
          userMessage = 'Resource not found.';
          break;
        case 500:
          userMessage = 'Server error. Please try again later.';
          break;
        default:
          userMessage = `Error: ${error.response.statusText || 'Unexpected response error.'}`;
      }
      error.userMessage = userMessage;
      console.warn('[API response error]', error.response.status, userMessage);
    } else if (error.request) {
      error.userMessage = 'Network error. Please check your connection.';
      console.warn('[API network error]', error.userMessage);
    } else {
      error.userMessage = `Error: ${error.message}`;
      console.warn('[API request error]', error.userMessage);
    }
    return Promise.reject(error);
  }
);

export default api;
